<app-modal-politica-termo *ngIf="!politicaTermoService.isAcceptedPoliciesAndTerms()"></app-modal-politica-termo>
<!-- 
<div class="app-titulo-pagina">
  <p>Bem vindo ao PicPontos</p>
</div> -->

<div
  *ngIf="mainService.permissionService.getPermissions() === undefined || mainService.cartaoService.isCompletos() === undefined"
  class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div *ngIf="mainService.permissionService.getPermissions() !== undefined && !mainService.sessionService.getIsVoucher()">
  <div *ngIf="mainService.loginService.clienteObservacao && mainService.cartaoService.isCompletos()"
    class="alert alert-observacao col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3" style="margin-top: 20px;"
    role="alert">
    <div class="col-xs-12 col-md-3">
      <i class="fa fa-exclamation-triangle" style="font-size: 90px" aria-hidden="true"></i>
    </div>
    <div class="col-xs-12 col-md-9 text-left" style="white-space: pre-line; min-height: 90px;">
      <div [innerHtml]="mainService.loginService.clienteObservacao"></div>
    </div>
  </div>

  <div *ngIf="mainService.saldoService.saldo.saldoPontosDevedor < 0"
    class="alert alert-danger col-xs-12 col-md-8 col-md-offset-2" style="margin-top: 20px; font-size: 1.5em;"
    role="alert">
    <strong>Atenção!
      Você possui saldo a devolver!</strong><br>
    <a (click)="mainService.loginService.changeRoute('/saldo')" style="cursor: pointer"> CLIQUE AQUI
    </a> e consulte seu extrato para mais informações.
  </div>

  <div *ngIf="mainService.cartaoService.isCompletos() === false"
    class="alert alert-warning col-xs-12 col-md-8 col-md-offset-2" style="margin-top: 20px;" role="alert">
    <strong>Atenção!</strong>
    <br> Seus dados pessoais ainda não foram preenchidos!<br>
    <a (click)="mainService.loginService.changeRoute('/cartao')" class="btn btn-success-v2">Preencher cadastro
    </a>
  </div>

  <div class="app-fundo-personalizado container">

    <div class="col-xs-12 col-md-10 col-md-offset-1 home-title-v2">
      <div>
        <h1 *ngIf="!isCustomized">
          Bem-Vindo(a) <br>
          ao PicPontos<img src="../../assets/img/home/balao.svg" alt="">
        </h1>
        <h1 *ngIf="isCustomized" style="margin-bottom: .5rem;">
          Bem-Vindo(a)!
        </h1>
      </div>
    </div>

    <div class="container col-xs-12 col-md-10 col-md-offset-1">
      <hr style="margin-top: 0;">
    </div>

    <div class="container col-xs-12 col-md-10 col-md-offset-1 home-descritivo-v2"
      *ngIf="mainService.cartaoService.isCompletos()">
      <div class="descricao">
        <h2>Aproveite ao máximo <br> sua premiação!</h2>
        <p>
          No PicPontos você escolhe como usa seus pontos! Realize compras, transferências, pagamentos, recargas de
          celular e presenteie quem você quiser!
        </p>
        <p>Tudo de um jeito fácil e descomplicado.</p>
      </div>

      <div class="links-navegacao">
        <img (click)="mainService.loginService.changeRoute('/saldo')"
          *ngIf="mainService.permissionService.hasPermission('funcionalidade:extrato_limitado')"
          src="../../assets/img/home/bt_roxo_extrato.svg" alt="">
        <img (click)="mainService.loginService.changeRoute('/pagamentos')"
          *ngIf="mainService.permissionService.hasPermission('funcionalidade:pagamento')"
          src="../../assets/img/home/bt_roxo_pag.svg" alt="">
        <img (click)="mainService.loginService.changeRoute('/transferencias')" *ngIf="mainService.permissionService.hasPermission('funcionalidade:ted') || mainService.permissionService.hasPermission('funcionalidade:ted_cartao') 
          || mainService.cartaoService.cartao.produto.bandeira" src="../../assets/img/home/bt_roxo_paycash.svg" alt="">
        <img (click)="mainService.loginService.changeRoute('/valepresente')"
          *ngIf="mainService.permissionService.hasPermission('funcionalidade:vale_presente')"
          src="../../assets/img/home/bt_roxo_vale.svg" alt="">
        <!-- <img (click)="mainService.loginService.changeRoute('/recarga/celular')"
          *ngIf="mainService.permissionService.hasPermission('funcionalidade:recarga_celular')"
          src="../../assets/img/home/bt_roxo_celular.svg" alt=""> -->
          <!-- <img (click)="mainService.loginService.changeRoute('/recarga/celular')"
          *ngIf="mainService.sessionService.getUserId() === 7"
          src="../../assets/img/home/bt_roxo_celular.svg" alt=""> -->
        <img (click)="mainService.loginService.changeRoute('/loja')"
          *ngIf="mainService.permissionService.hasPermission('funcionalidade:loja')"
          src="../../assets/img/home/bt_roxo_loja.svg" alt="">
      </div>
    </div>

  </div>

</div>


<!-- Modal de vários avisos -->
<!-- <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
          </ol>

          <div class="carousel-inner" role="listbox">
            <div class="item active">
              <img src="assets/img/avisos/Best+Pontos_Instabilidade.jpg" class="hidden-xs centralizar"
                alt="Aviso de Feriado">
              <img src="assets/img/avisos/Best+Pontos_Instabilidade_Mobile.jpg" class="visible-xs centralizar"
                alt="Aviso de Feriado">
            </div>
            <div class="item">
              <img src="assets/img/avisos/Best+Pontos_Comunicado_Telefone.jpg" class="hidden-xs centralizar"
                alt="Aviso alteração de telefone">
              <img src="assets/img/avisos/Best+Pontos_Comunicado_Telefone_Mobile.jpg" class="visible-xs centralizar"
                alt="Aviso alteração de telefone">
            </div>
          </div>

          <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div> -->

<!-- Modal -->
<!-- <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <img src="assets/img/avisos/aviso_natal_ano-novo.png" class="hidden-xs centralizar"
          alt="Aviso final de ano">
        <img src="assets/img/avisos/aviso_natal_ano-novo.png" class="visible-xs centralizar"
          alt="Aviso final de ano">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>  -->


// WEBPACK FOOTER //
// ./src/app/home/home.component.html